import { render, staticRenderFns } from "./AlertReasonEditor.vue?vue&type=template&id=2d33d26f&"
import script from "./AlertReasonEditor.vue?vue&type=script&lang=js&"
export * from "./AlertReasonEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports